/**
 * Central query-key factory.
 *
 * One place for query keys so hook reads and (in Phase B) loader primes line up on the exact same
 * key. Keys are arrays: a stable string head names the resource, followed by the params that vary
 * the request. Include EVERY request-affecting param in the key, or a cached entry can go stale
 * against the URL that produced it.
 */

export interface ListQueryParams {
  pageNumber: number;
  pageSize: number;
  sortField: string;
  sortDescending: boolean;
  /** Server-side filter values, endpoint-specific. */
  filters?: Record<string, string | number | boolean>;
  /**
   * Which transport carried the filters — `"post"` for the PHI list searches (AUD-21). It is a
   * request-affecting param like any other, so it belongs in the key: two transports hitting
   * different routes must not share a cache entry.
   */
  method?: "get" | "post";
}

export const queryKeys = {
  identity: ["identity"] as const,

  /** A dashboard payload, scoped by audience (e.g. "patient", "clinical"). */
  dashboard: (scope: string) => ["dashboard", scope] as const,

  /** A server-paged MtcList query, keyed on endpoint + paging/sort/filter. */
  list: (endpoint: string, params: ListQueryParams) =>
    ["list", endpoint, params] as const,
};
